import React, { useState, useEffect, useRef } from "react";
import "./ChatBot.css";

const ChatBot = () => {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Welcome to Admissions Express! How can I assist you today?" },
  ]);
  const [input, setInput] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [typing, setTyping] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const chatEndRef = useRef(null);

  // Scroll to the end whenever a new message is added

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, faqList]);

  useEffect(() => {

    // Fetch FAQs from backend when the chatbot opens

    fetch(process.env.REACT_APP_FOR_UPLOADS_URL+"/faqs")
      .then((response) => response.json())
      .then((data) => setFaqList(data.slice(0, 3))) // Show 2-3 FAQs initially
      .catch((error) => console.error("Error fetching FAQs:", error));
  }, []);

  const handleSendMessage = (messageText) => {
    if (messageText.trim()) {
      setMessages((prev) => [...prev, { sender: "user", text: messageText }]);
      setInput("");
      setFaqList([]);
      setTyping(true);

      // Send the message to the backend

      fetch(process.env.REACT_APP_FOR_UPLOADS_URL+"/ask", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: messageText }),
      })
        .then((response) => response.json())
        .then((data) => {
          setTyping(false);
          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              text: data.answer || "I'm sorry, I couldn't find an answer. Please try rephrasing.",
            },
          ]);
        })
        .catch((error) => {
          setTyping(false);
          setMessages((prev) => [
            ...prev,
            {
              sender: "bot",
              text: "There was an error connecting to the server. Please try again later.",
            },
          ]);
          console.error("Error sending message:", error);
        });
    }
  };

  const handleFAQClick = (faq) => {
    handleSendMessage(faq);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);

    // Show FAQs as suggestions when typing
    
    if (value.trim()) {
      fetch(process.env.REACT_APP_FOR_UPLOADS_URL+"/faqs")
        .then((response) => response.json())
        .then((data) => {
          const matchedSuggestions = data.filter((question) =>
            question.toLowerCase().includes(value.toLowerCase())
          );
          setFaqList(matchedSuggestions.slice(0, 3)); // Show top 2-3 matches
        })
        .catch((error) => console.error("Error fetching suggestions:", error));
    } else {
      setFaqList([]);
    }
  };

  return (
    <div className="chatbot-container">
      {isOpen ? (
        <div className="chatbot">
          <div className="chatbot-header">
            Admissions Express Chatbot
            <button className="close-button" onClick={() => setIsOpen(false)}>
              ✕
            </button>
          </div>
          <div className="chatbot-body">
            {messages.map((message, index) => (
              <div key={index} className={`message ${message.sender}`}>
                            <div dangerouslySetInnerHTML={{ __html: message.text }} />
              </div>
            ))}
            {faqList.length > 0 && (
              <div className="chatbot-recommendations">
                {faqList.map((faq, index) => (
                  <button
                    key={index}
                    className="recommendation-button"
                    onClick={() => handleFAQClick(faq)}
                  >
                    {faq}
                  </button>
                ))}
              </div>
            )}
            {typing && <div className="message bot">Typing...</div>}
            <div ref={chatEndRef}></div>
          </div>
          <div className="chatbot-footer">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={handleInputChange}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage(input)}
            />
            <button onClick={() => handleSendMessage(input)}><i class="fa fa-paper-plane"></i></button>
          </div>
        </div>
      ) : (
        <div className="chat-icon" onClick={() => setIsOpen(true)}>
          <i class="fa fa-comments-o" aria-hidden="true"></i>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
